"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.28 3.555a.7.7 0 0 1 .99 0l4.725 4.725a.7.7 0 0 1 0 .99L9.27 13.995a.7.7 0 0 1-.99 0L3.555 9.27a.7.7 0 0 1 0-.99zm-3.24 5.22 3.735 3.735 3.735-3.735L8.775 5.04z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.988 7.375a.612.612 0 1 0 0 1.225.612.612 0 0 0 0-1.225m0 1.4a.787.787 0 1 0 0-1.575.787.787 0 0 0 0 1.575",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.343 4.343a.7.7 0 0 1 .99 0l3.15 3.15a.7.7 0 1 1-.99.99l-3.15-3.15a.7.7 0 0 1 0-.99M15.036 14.99c.162-.141.214-.289.214-.407l-.002-.018-.01-.056q-.015-.075-.061-.2a4 4 0 0 0-.307-.604 9 9 0 0 0-.582-.835 9 9 0 0 0-.582.835q-.21.347-.307.604a1.4 1.4 0 0 0-.072.256l-.002.018c0 .118.052.266.214.408.165.144.425.259.749.259.323 0 .583-.115.748-.26m-.748 1.66c1.304 0 2.362-.925 2.362-2.067 0-.956-.99-2.284-1.69-3.101a.878.878 0 0 0-1.346 0c-.698.817-1.689 2.145-1.689 3.1 0 1.143 1.058 2.068 2.362 2.068",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BackgroundColorIcon20.js.map